<template>
	<div class="container full flex" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.8)">
		<div class="tabcontainer flex">
			<el-button size="mini" type="danger" @click="getPurchase(1)">未到货</el-button>
			<el-button size="mini" type="success" @click="getPurchase(3)">已完成</el-button>
		</div>
		<div class="searcontainer">
			<el-input size="mini" placeholder="请输入单号" v-model="billCode" @input="searchchange"></el-input>
		</div>
		<div class="ordercontainer">
			<ul class="purchaseorderList">
				<li class="purchaseorderItem" :class="{'active':item.active==1}" v-for="(item,index) in purchase"
					:key="index" @click="activeorder(item.billID)">
					<div class="ordercontaner flex">
						<div style="display: inline-block;">{{item.billCode}}</div>
						<el-tag effect="dark" size="mini"
							:type="purchaseStatusMap[item.status].type"
							v-if="purchaseStatusMap[item.status]">{{ purchaseStatusMap[item.status].status }}</el-tag>
					</div>
					<el-tag style="margin-right: 10px;" size="mini">已报</el-tag>
					<el-tag style="margin-right: 10px;" type="success" size="mini" v-if="item.status==3">回单</el-tag>
				</li>

			</ul>
		</div>
	</div>
</template>
<style scoped>
	.container {
		flex-direction: column;
	}

	.tabcontainer {
		flex-direction: row;
		margin: 10px 0;
		padding: 0 6px;
	}

	.tab {
		background-color: black;
		color: white;
		width: 100px;
		border-radius: 6px;
		overflow: hidden;
	}

	.searcontainer {
		margin: 10px 0;
		padding: 0 6px;
		box-sizing: border-box;
	}

	.ordercontainer {
		position: relative;
		flex: 1;
		overflow: auto;
	}

	.purchaseorderList {
		position: absolute;
		width: 100%;
		font-size: 16px;
		box-sizing: border-box;
		color: white;
		padding: 4px;
		cursor: pointer;
	}

	.purchaseorderItem {
		position: relative;
		background-color: #303133;
		padding: 4px;
		margin-bottom: 6px;
		box-sizing: border-box;
		border-bottom: 2px solid #909399;
	}

	.purchaseorderItem.active {
		background-color: #606266;
	}
	.ordercontaner{
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
	}
</style>

<script>
	export default {
		props: {
			title: {
				type: String,
				default: () => {
					return '供应商'
				}
			},
			row: {
				default: () => {
					return null
				}
			},
		},
		data() {
			return {
				loading: false,
				sourcepurchase: [],
				purchase: [],
				billCode: '',
				purchaseStatusMap: {
					0: null,
					5: {
						status: '审核中',
						type: 'info'
					},
					6: {
						status: '审核中',
						type: 'warning'
					},
					1: {
						status: '未到货',
						type: 'danger'
					},
					2: {
						status: '部分到货',
						type: 'primary'
					},
					3: {
						status: '完成',
						type: 'success'
					},
					4: {
						status: '关闭',
						type: 'info'
					},
					7: {
						status: '退单失败',
						type: 'info'
					},
					8: {
						status: '已拒绝',
						type: 'info'
					},
				}
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {
			this.init()
		},
		methods: {
			init() {
				this.getPurchase()
			},
			getPurchase(status = 1) {
				this.billCode = ''
				this.loading = true
				let wlnid = this.row.wlnid
				this.$api.wechaty.getPurchase(wlnid, {
					status: status
				}).then((res) => {
					res.forEach((item) => {
						item.active = 0
					})
					this.sourcepurchase = res
					this.purchase = res
					this.loading = false
				})
			},
			searchchange(e) {
				this.purchase = this.sourcepurchase.filter((item) => {
					return item.billCode.includes(e)
				})
			},
			getActiveOrder() {
				let order = null
				this.purchase.forEach((item) => {
					if (item.active == 1) {
						order = item
					}
				})
				return order
			},
			activeorder(billID) {
				console.log(this.purchase, billID)
				this.purchase.forEach((item) => {
					item.active = 0
					if (item.billID == billID) {
						item.active = 1
					}
				})
				this.$emit('orderchange', {
					order: this.getActiveOrder()
				})
			}
		},
		components: {

		}
	}
</script>